import {Handedness, PoolTabsType, PositionType, StatusType, ProbabilityBench} from "modules/enums";
import {createAction} from "redux-act";

export const getPlayersJson = createAction();

interface IStats {
	hits: number;
	atBats: number;
	avg: number;
	wins: number;
	losses: number;
	earnedRunAverage: number;
	chance: number;
}

interface IStatsLastMatch extends IStats {
	result: string;
	streak: number;
}

interface ILineup {
	playerId: number;
	lineupNumber: number | null;
	bench: number | null;
	starter: number | null;
	type: ProbabilityBench | null;
}

interface IPlayer {
	id: number;
	squadId: number;
	feedId: number;
	name: string;
	lastName: string;
	firstName: string;
	position: PositionType;
	status: StatusType;
	isPopular: boolean;
	isHotStreak: boolean;
	isPitcherHitter: boolean;
	isSuggested: boolean;
	headshot: null | string;
	actionShotImage: null | string;
	actionFullImage: null | string;
	stats: Partial<IStats> | null;
	numberSelections: number;
	lastUnitResults: IStatsLastMatch | null;
	streak: number | null;
	handedness: Handedness;
	lineup?: ILineup | null;
}

interface IPlayerSuccessRespond {
	players: Record<number, IPlayer>;
	poolPlayers: Record<PoolTabsType, number[]>;
}

export const getPlayersJsonSuccess = createAction<IPlayerSuccessRespond>();
export const getPlayersJsonFailed = createAction();

interface ISuggestedPlayers {
	suggestedPlayers: ISuggestedPlayer[];
}

interface ISuggestedPlayer {
	roundId: number;
	playerId: number;
	probabilityStarter: number;
}

export const getPlayersSuggestedJsonSuccess = createAction<ISuggestedPlayers>();
